import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {Typography} from "@material-ui/core";


export default function BrokerageDropDown({top, dispatchTop}) {
    //const [value, setValue] = useState(values[0]);
    let values = [];
    if (top.dataSource === "LIVE") {
        values = [{label: "TRADIER", value: "TRADIER"}, {label: "SIMULATED", value: "BACKTEST"}];
    } else {
        values = [{label: "SIMULATED", value: "BACKTEST"}];
    }
    return (<>
        <TextField
            select
            value={top.brokerage !== "none" ? top.brokerage : ""}
            variant="outlined"
            size="small"
            style={{backgroundColor: "white", width: "100%"}}
            onChange={ev => dispatchTop({brokerage: ev.target.value})}
            label={<Typography style={{fontSize: 10}}>Brokerage</Typography>}
        >
            {values.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    <Typography style={{fontSize: 9}}>{option.label}</Typography>
                </MenuItem>
            ))}
        </TextField>
    </>);
}